mutation DeletePosts($ids: [ID!]!) {
  deletePosts(ids: $ids) {
    id
  }
}
